export default {"src":"/_next/static/media/wplLogo.bb6c7637.svg","height":49,"width":46};